export const hasValidLicence = (state) => {
    return state.app.licence.value.mayRun();
};



// WEBPACK FOOTER //
// ./src/js/projections/licence.js